import { startOfToday } from "_utils/dateUtils";
import { useUserSettings } from "domain/userSettings/hooks/userSettingsContext";
import React, { createContext, useContext, useState } from "react";

import { FlightSearchCriteria } from "../models/flightSearchCriteria";

const defaultSearchCriteria: FlightSearchCriteria = {
  airportCode: "",
  travelRadius: 1,
  direction: "from",
  date: startOfToday(),
};

interface FlightSearchContext {
  readonly searchCriteria: FlightSearchCriteria;
  readonly setSearchCriteria: (state: FlightSearchCriteria) => void;
  readonly companyCode: string;
  readonly isMetric: boolean;
}

const flightSearchContext = createContext<FlightSearchContext | undefined>(undefined);

export const FlightSearchProvider = ({ children }: FlightSearchProviderProps) => {
  const { userSettings } = useUserSettings();
  const { isMetric, companyCode, defaultAirportCode } = userSettings;
  const [searchCriteriaInner, setSearchCriteria] = useState<FlightSearchCriteria>(undefined);
  const searchCriteria: FlightSearchCriteria = {
    ...defaultSearchCriteria,
    airportCode: defaultAirportCode,
    ...searchCriteriaInner,
  };

  const setSearchCriteriaWithFormatting = (searchCriteria: FlightSearchCriteria) => {
    setSearchCriteria({
      ...searchCriteria,
      airportCode: searchCriteria.airportCode.toUpperCase(),
    });
  };

  const value = {
    searchCriteria,
    setSearchCriteria: setSearchCriteriaWithFormatting,
    companyCode,
    isMetric,
  };
  return <flightSearchContext.Provider value={value}>{children}</flightSearchContext.Provider>;
};
interface FlightSearchProviderProps {
  children: React.ReactNode;
}

export const useFlightSearchState = () => {
  const context = useContext(flightSearchContext);
  if (context === undefined) {
    throw new Error("useFlightSearchState must be used within a FlightSearchProvider");
  }
  return context;
};
